import {AbstractControl, ValidatorFn} from '@angular/forms';

import {LatinLettersAndSpecialSymbolsAndWhiteSpaceValidatorKey} from './custom-validator-keys';

export function LatinLettersAndSpecialSymbolsAndWhiteSpaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value;

        if (!controlValue) {
            return null;
        }

        const regex = new RegExp(/^[a-zA-Z0-9`~!@#$%^&*()_+\-=\[\]{}\\|;':",.\/<>? ]+$/);

        return !regex.test(controlValue) ? {[LatinLettersAndSpecialSymbolsAndWhiteSpaceValidatorKey]: true} : null;
    };
}
